import { render, staticRenderFns } from "./rongyu.vue?vue&type=template&id=72bb7da0&"
import script from "./rongyu.vue?vue&type=script&lang=js&"
export * from "./rongyu.vue?vue&type=script&lang=js&"
import style0 from "./rongyu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports